(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('security-roles', {
            parent: 'nasrac-admin',
            url: '/security-roles',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.securityRoles.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/security-roles/security-roles.html',
                    controller: 'SecurityRolesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('securityRoles');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('security-roles-detail', {
            parent: 'security-roles',
            url: '/security-roles/{id}',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.securityRoles.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/nasrac-admin/security-roles/security-roles-detail.html',
                    controller: 'SecurityRolesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('securityRoles');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SecurityRoles', function($stateParams, SecurityRoles) {
                    return SecurityRoles.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'security-roles',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('security-roles-detail.edit', {
            parent: 'security-roles-detail',
            url: '/detail/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/security-roles/security-roles-dialog.html',
                    controller: 'SecurityRolesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SecurityRoles', function(SecurityRoles) {
                            return SecurityRoles.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('security-roles.new', {
            parent: 'security-roles',
            url: '/new',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/security-roles/security-roles-dialog.html',
                    controller: 'SecurityRolesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                securityRoleName: null,
                                securityRoleDesc: null,
                                securityRoleGroup: null,
                                publicRoleFlag: false,
                                autoAssignFlag: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('security-roles', null, { reload: 'security-roles' });
                }, function() {
                    $state.go('security-roles');
                });
            }]
        })
        .state('security-roles.edit', {
            parent: 'security-roles',
            url: '/{id}/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/security-roles/security-roles-dialog.html',
                    controller: 'SecurityRolesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SecurityRoles', function(SecurityRoles) {
                            return SecurityRoles.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('security-roles', null, { reload: 'security-roles' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('security-roles.delete', {
            parent: 'security-roles',
            url: '/{id}/delete',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nasrac-admin/security-roles/security-roles-delete-dialog.html',
                    controller: 'SecurityRolesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SecurityRoles', function(SecurityRoles) {
                            return SecurityRoles.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('security-roles', null, { reload: 'security-roles' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
